import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleNotch, faMapMarkedAlt, faTimes, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import PerfectScrollbar from 'react-perfect-scrollbar'
import {Alert}from 'evergreen-ui'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';

import {
    changeTrackingNrArr
} from '../redux/Tracefully/AppSettings';


const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        changeTrackingNrArr: changeTrackingNrArr
    }, dispatch)
};
const mapStateToProps = function (state) {
    return {
        AppSettings: state.AppSettings,
        UserSettings: state.UserSettings
    }
};

class NumberBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            extended: false,
            extendedClass: '',
            placeholder: "click here to add up to 20 numbers",
            trackingNrArr: [
                {tnr: '', ref: React.createRef()}
            ],
            focusIndex:-1,
            needsFullExpand:false,
        };
    }

    componentDidMount() {

        if (this.props.id == 1) {
            this.setState({extended: true});
        }
        this.focusInit();

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.focusIndex == -1) {
            this.focusLast();
            //this.props.AppSettings.trackingNrArr[index - 1].ref.focus()
        } else {
            this.props.AppSettings.trackingNrArr[this.state.focusIndex].ref.focus()
        }
        if ( this.state.needsFullExpand == true){
            this.state.needsFullExpand=false;
            for (let i = 0; i < this.props.AppSettings.trackingNrArr.length; i++) {
                this.autoExpand(this.props.AppSettings.trackingNrArr[i].ref);
            }
        }
    }
    focusInit(){
        if(this.props.AppSettings.trackingNrArr.length>0){
            if (this.props.AppSettings.trackingNrArr[this.props.AppSettings.trackingNrArr.length - 1].tnr!="") {
                let temp = this.props.AppSettings.trackingNrArr;
                temp.push({tnr: '', ref: React.createRef()});
                if (temp.length == 1) {
                    this.setState({placeholder: "click here to add up to 40 numbers"})
                } else {
                    this.setState({placeholder: ""})
                }
                this.props.changeTrackingNrArr(temp)
                this.state.focusIndex = -1;

            }else{
                this.props.AppSettings.trackingNrArr[this.props.AppSettings.trackingNrArr.length - 1].ref.focus()
            }

        }
    }

    focusLast(){
        if(this.props.AppSettings.trackingNrArr[this.props.AppSettings.trackingNrArr.length - 1]){
            this.props.AppSettings.trackingNrArr[this.props.AppSettings.trackingNrArr.length - 1].ref.focus()
        }

    }

    updateNumbers(trackNrs) {
        if (trackNrs.length > 0) {
            let tempTrackingNrArr = this.state.trackingNrArr;
            let insertcounter = 0;
            for (let i = 0; i < trackNrs.length; i++) {
                trackNrs[i] = trackNrs[i].replace(/[^A-Za-z0-9]/g, '');
                if (trackNrs[i] !== "") {
                    tempTrackingNrArr.push({tnr: trackNrs[i], ref: React.createRef()});
                }
            }
            this.setState({trackingNrArr: tempTrackingNrArr}, () => {
                for (let i = 0; i < insertcounter; i++) {
                    this.autoExpand(this.state.trackingNrArr[i].ref);
                }
            })
        }
    }

    buildTrackNrList() {

        let TrackNrItems = this.props.AppSettings.trackingNrArr.map((item, index) => {
            let rowcolor = ''
            if (index % 2 == 1) {
                rowcolor = 'unequal';
            }
            return (
                <div className={"trackNrItem " + rowcolor} key={index} onClick={(e) => this.focusBox(e, index)}>
                    <div className="columns w-row">
                        <div className="w-col w-col-1 w-col-small-1 w-col-tiny-1">
                            <div>
                                <div className="RowNumber">{index + 1}.</div>
                            </div>
                        </div>
                        <div className="w-col w-col-10 w-col-small-10 w-col-tiny-10">
                            <div>
                                <textarea
                                    ref={(textarea) => {
                                        item.ref = textarea;
                                    }}
                                    placeholder={this.state.placeholder}
                                    rows="1"
                                    className="text-block-83 trackingNrInput"
                                    onChange={(e) => this.changetrackignNr(e, index)}
                                    onKeyUp={(e) => this.onEnterPress(e, index)}
                                    onPaste={(e) => this.onPaste(e, index)}
                                    value={item.tnr}/>
                            </div>
                        </div>
                        <div className="w-col w-col-1 w-col-small-1 w-col-tiny-1">
                            <div className="remove-tnr-container" onClick={(e) => this.removeTnr(e,index)}>

                                <FontAwesomeIcon className="remove-tnr" icon={faTimes}/>
                            </div>
                        </div>
                    </div>
                </div>)
        });
        return TrackNrItems
    }

    removeTnr(e,index) {

        if (this.props.AppSettings.trackingNrArr.length >= 2) {
            this.props.onRemove(index);
            let temp = this.props.AppSettings.trackingNrArr;
            temp.splice(index, 1);
            if (index > 0) {
                this.props.changeTrackingNrArr(temp)
                this.state.focusIndex = -1;
                //this.props.AppSettings.trackingNrArr[index - 1].ref.focus()

            } else {
                this.props.changeTrackingNrArr(temp)
                this.state.focusIndex = -1;
                //this.props.AppSettings.trackingNrArr[0].ref.focus()

            }
        } else {
            let temp = this.props.AppSettings.trackingNrArr;
            this.props.onRemove(index);
            temp[index].tnr = '';
            this.props.changeTrackingNrArr(temp)
            this.state.focusIndex = -1;
            //this.props.AppSettings.trackingNrArr[0].ref.focus()
            if (temp.length == 1) {
                this.setState({placeholder: "click here to add up to 20 numbers"})
            } else {
                this.setState({placeholder: ""})
            }

        }
        e.stopPropagation();
    }

    removeAll(){
        let trackingNrArr= [
            {tnr: '', ref: React.createRef()}
        ];
        this.props.changeTrackingNrArr(trackingNrArr)
        this.props.onRemoveAll();
    }

    changetrackignNr(e, index) {
        if (e.target.value.includes('\n')) {

        } else {
            let temp = this.props.AppSettings.trackingNrArr;
            temp[index].tnr = e.target.value.replace(/[^A-Za-z0-9]/g, '');
            this.autoExpand(event.target);
            this.props.changeTrackingNrArr(temp)

        }
    }

    onPaste(e, index) {
        let temp = e.clipboardData.getData('Text');
        temp = temp.split(/[\n,;\s]+/);
        if (temp.length > 0) {
            let tempTrackingNrArr = this.props.AppSettings.trackingNrArr;
            let insertcounter = 0;
            for (let i = 0; i < temp.length; i++) {
                if(tempTrackingNrArr.length <20){
                    temp[i] = temp[i].replace(/[^A-Za-z0-9]/g, '');
                    if (temp[i] !== "") {
                        if (i == 0) {
                            tempTrackingNrArr[index].tnr = tempTrackingNrArr[index].tnr + temp[i];
                        } else {
                            tempTrackingNrArr.splice(index + i, 0, {tnr: temp[i], ref: React.createRef()});
                        }
                        insertcounter = insertcounter + 1;


                    }
                    this.props.changeTrackingNrArr(tempTrackingNrArr)
                    this.state.needsFullExpand=true;
                }
            }

        }
        e.preventDefault();
        e.stopPropagation();
    }

    autoExpand(field) {

        field.style.height = 'inherit';
        var height = field.scrollHeight;
        field.style.height = height + 'px';

    };

    onEnterPress(e, index) {
        if (this.props.AppSettings.trackingNrArr.length < 20 ){
            if (e.keyCode === 13 && this.props.AppSettings.trackingNrArr[index].tnr !== "") {
                let temp = this.props.AppSettings.trackingNrArr;
                temp.push({tnr: '', ref: React.createRef()});
                if (temp.length == 1) {
                    this.setState({placeholder: "click here to add up to 40 numbers"})
                } else {
                    this.setState({placeholder: ""})
                }
                this.props.changeTrackingNrArr(temp)
                this.state.focusIndex = -1;

            } else if (e.keyCode === 8 || e.keyCode === 46) {
                if (this.props.AppSettings.trackingNrArr[index].tnr === "" && index > 0) {
                    let temp = this.props.AppSettings.trackingNrArr;
                    temp.splice(index, 1);
                    this.props.changeTrackingNrArr(temp)
                    this.state.focusIndex = -1;
                }
            }
        }


    }

    focusBox(e, index) {

        this.state.focusIndex=index;
        this.props.AppSettings.trackingNrArr[index].ref.focus();
        e.stopPropagation();
    }

    startTrack() {
        this.props.onTrack()
    }


    render() {

        let trackNrItems = this.buildTrackNrList();
        let buttonWidth = {float:'left',width:'100%'}

        if(this.props.AppSettings.trackingNrArr.length > 0 && this.props.AppSettings.trackingNrArr[0].tnr!=""){
            buttonWidth = 'calc(100%-50px)'
            buttonWidth = {float:'left',width:'calc(100% - 60px)'}
        }
        return (
            <div className="w-col">

                    <div className="trackingnrbox"
                         onClick={() => this.focusLast()}>
                        <PerfectScrollbar options={{
                            wheelPropagation: true,
                            swipeEasing: true
                        }}>
                        {trackNrItems}
                        </PerfectScrollbar>

                    </div>

                {this.props.AppSettings.trackingNrArr.length>=20 &&
                <Alert
                    marginTop = {3}
                    appearance="card"
                    intent="danger"
                    title="You can only track 20 Numbers at once"
                />}


                <div style={{width:'100%'}}>
                    <div style={buttonWidth}>
                        <button type="submit" className={` ${this.props.loading ? 'btn-deactivated animate ' : 'btn btn-primary'}`} style={{marginTop: "5px"}}
                                onClick={() => {!this.props.loading && this.startTrack()}}>
                            {this.props.loading ? (
                                <div style={{height:'35px'}}>

                                </div>
                            ):(
                                <FontAwesomeIcon style={{marginRight: '10px'}} icon={faMapMarkedAlt}/>
                            )}
                            {this.props.loading ? (''):('TRACK')}
                        </button>
                    </div>
                    { (this.props.AppSettings.trackingNrArr.length > 0 &&this.props.AppSettings.trackingNrArr[0].tnr!="")  && (

                        <div style={{float:'right',minWidth:'50px'}}>
                            <button type="submit" className="btn btn-secondary" style={{marginTop: "5px"}}
                                    onClick={() => this.removeAll()}>
                                <FontAwesomeIcon style={{color:'#484848'}} icon={faTrashAlt}/>
                            </button>
                        </div>
                    )}

                </div>




            </div>
        );
    }
}

//TrackItem.propTypes = propTypes;
export default connect(
    mapStateToProps,
    mapDispatchToProps
)

(
    NumberBox
)
;
